var competitions_container = document.getElementsByClassName("award-block-item");
var competition_detail;
var competition_data;
let pivot;


for(const competition of competitions_container){
    competition_detail = competition.getElementsByClassName("award-information");
  	competition_detail = competition_detail[0].innerText;
  	competition_data = competition_detail.split('"');
  pivot = 0;
  for(let iterator = 1; iterator < competition_data.length; iterator++){
    if(iterator % 2 != 0){
      pivot++;
      switch(pivot){
        case 1:
          competition.innerHTML += 
            `<div class="award-paragraph">
				<p>${competition_data[iterator]} | ${competition_data[iterator + 2]}</p>
				<p>
					<a href="${competition_data[iterator + 6]}">${competition_data[iterator + 4]}</a>
             </div>`
          break;
        case 4:
          pivot = 0;
          break;
      }
    }
  }
}

function lastAward(selector) {
    let move_position = 0;
    var card = document.getElementsByClassName('award-block-container');
    move_position = card[0].offsetWidth + 20;
    var carousel_selected = selector.nextElementSibling.firstElementChild;
    let actual_position = parseInt(carousel_selected.getAttribute("actualPosition"));
    if (actual_position > 0) {
        actual_position -= move_position;
        carousel_selected.scrollLeft -= move_position;
        carousel_selected.setAttribute("actualPosition", actual_position); 
        selector.nextElementSibling.nextElementSibling.style.visibility = "visible";
        selector.nextElementSibling.nextElementSibling.firstElementChild.style.visibility = "visible";
        if(actual_position <= 0) {
            selector.style.visibility = "hidden";
            selector.firstElementChild.style.visibility = "hidden";
        }
    }
}

function nextAward(selector) {
    let move_position = 0;
    var card = document.getElementsByClassName('award-block-container');
    move_position = card[0].offsetWidth + 20;
    var carousel_selected = selector.previousElementSibling.firstElementChild;
    let actual_position = parseInt(carousel_selected.getAttribute("actualPosition"));
    if (actual_position >= 0) {
        actual_position += move_position;
        carousel_selected.scrollLeft += move_position;
        carousel_selected.setAttribute("actualPosition", actual_position); 
        selector.previousElementSibling.previousElementSibling.style.visibility = "visible";
        selector.previousElementSibling.previousElementSibling.firstElementChild.style.visibility = "visible";
        let trackWidth = (carousel_selected.scrollWidth - move_position);
        if(actual_position > trackWidth - 2) {
            selector.style.visibility = "hidden";
            selector.firstElementChild.style.visibility = "hidden";
        }
    }
} 

function changePosition(carousel_selected){
  let leftScrolling = carousel_selected.scrollLeft;
  carousel_selected.setAttribute("actualPosition", leftScrolling);
  let carousel_item = carousel_selected.getAttribute("ItemClass");
  let button_next = carousel_selected.getAttribute("nextClass");
  let button_prev = carousel_selected.getAttribute("prevClass");
  carousel_item = carousel_selected.getElementsByClassName(carousel_item);
  let move_position = carousel_item[0].offsetWidth + parseInt(getComputedStyle(carousel_item[0]).marginLeft) + parseInt(getComputedStyle(carousel_item[0]).marginRight);
  let trackWidth_aux = move_position * carousel_item.length * -1;
  let big_carousel = carousel_selected.parentNode;
  big_carousel = big_carousel.parentNode;
  button_next = big_carousel.getElementsByClassName(button_next);
  button_prev = big_carousel.getElementsByClassName(button_prev);
  if(leftScrolling > trackWidth_aux){
      button_next[0].style.display = "flex";
  }
  if(((leftScrolling + window.innerWidth) * -1) <= trackWidth_aux){
      button_next[0].style.display = "none";
  }
  if(leftScrolling > 0){
      button_prev[0].style.visibility = "visible";
  }
  if(leftScrolling == 0){
      button_prev[0].style.visibility = "hidden";
  }
}